import Step from './step';
import { NewApplicationStepStatus } from '../../hoc/new-application/types';
import { StepsTypes } from './types';

import cn from './new-application.module.css';

const Steps = ({
  steps,
  isCorporate,
  isCompanyOfficial,
  applicationScheme,
  customersSuppliersStepEnabled,
}: StepsTypes) => (
  <div className={cn.steps}>
    <Step
      status={steps?.stepOne as NewApplicationStepStatus}
      title="Step 1"
      id="step-1"
    />
    {((!isCompanyOfficial && !isCorporate) ||
      (isCorporate && customersSuppliersStepEnabled)) && (
      <Step
        status={steps?.stepTwo as NewApplicationStepStatus}
        title="Step 2"
        id="step-2"
      />
    )}

    {!isCorporate && !isCompanyOfficial && (
      <>
        {(!applicationScheme ||
          (applicationScheme && applicationScheme.kycProvider !== 'NONE')) && (
          <Step
            status={steps?.stepThree as NewApplicationStepStatus}
            title="Step 3"
            id="step-3"
          />
        )}

        <Step
          status={steps?.stepFive as NewApplicationStepStatus}
          title={
            !applicationScheme ||
            (applicationScheme && applicationScheme.kycProvider !== 'NONE')
              ? 'Step 4'
              : 'Step 3'
          }
          id="step-4"
        />
      </>
    )}
    {isCompanyOfficial && (
      <>
        {(!applicationScheme ||
          (applicationScheme && applicationScheme.kycProvider !== 'NONE')) && (
          <Step
            status={steps?.stepTwo as NewApplicationStepStatus}
            title="Step 2"
            id="step-2"
          />
        )}
        <Step
          status={steps?.stepFour as NewApplicationStepStatus}
          title={
            !applicationScheme ||
            (applicationScheme && applicationScheme.kycProvider !== 'NONE')
              ? 'Step 3'
              : 'Step 2'
          }
          id="step-3"
        />
        {(!applicationScheme ||
          (applicationScheme && applicationScheme.agreementsActive) ||
          (applicationScheme &&
            applicationScheme.agreementsActive === null)) && (
          <Step
            status={steps?.stepThree as NewApplicationStepStatus}
            title={
              !applicationScheme ||
              (applicationScheme && applicationScheme.kycProvider !== 'NONE')
                ? 'Step 4'
                : 'Step 3'
            }
            id="step-4"
          />
        )}
      </>
    )}

    {steps?.stepFour &&
      !isCorporate &&
      !isCompanyOfficial &&
      (!applicationScheme ||
        (applicationScheme && applicationScheme.agreementsActive) ||
        (applicationScheme && applicationScheme.agreementsActive === null)) && (
        <Step
          status={steps?.stepFour}
          title={
            !applicationScheme ||
            (applicationScheme && applicationScheme.kycProvider !== 'NONE')
              ? 'Step 5'
              : 'Step 4'
          }
          id="step-5"
        />
      )}
    {isCorporate && (
      <>
        <Step
          status={steps?.stepThree as NewApplicationStepStatus}
          title={customersSuppliersStepEnabled ? 'Step 3' : 'Step 2'}
          id="step-3"
        />
        <Step
          status={steps?.stepFour as NewApplicationStepStatus}
          title={customersSuppliersStepEnabled ? 'Step 4' : 'Step 3'}
          id="step-4"
        />
        <Step
          status={steps?.stepFive as NewApplicationStepStatus}
          title={customersSuppliersStepEnabled ? 'Step 5' : 'Step 4'}
          id="step-5"
        />
        <Step
          status={steps?.stepEight as NewApplicationStepStatus}
          title={customersSuppliersStepEnabled ? 'Step 6' : 'Step 5'}
          id="step-6"
        />
        <Step
          status={steps?.stepSix as NewApplicationStepStatus}
          title={customersSuppliersStepEnabled ? 'Step 7' : 'Step 6'}
          id="step-7"
        />
        {((applicationScheme && applicationScheme.agreementsActive) ||
          !applicationScheme ||
          (applicationScheme &&
            applicationScheme.agreementsActive === null)) && (
          <Step
            status={steps?.stepSeven as NewApplicationStepStatus}
            title={customersSuppliersStepEnabled ? 'Step 8' : 'Step 7'}
            id="step-8"
          />
        )}
      </>
    )}
  </div>
);

export default Steps;
